import { Link, useLocation } from 'react-router-dom';
import { PageHeader } from '@/components/ui/PageHeader';

/** An address the portal has no page for. It says so, and gives the two places a person is most likely looking for. */
export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <>
      <PageHeader title="Page not found" />
      <p className="mt-4">
        The portal has no page at <code>{pathname}</code>.
      </p>
      <p>
        Go to <Link to="/">Home</Link> or see <Link to="/tools">all tools</Link>.
      </p>
    </>
  );
}
